import {
  REPOS_AUTO_DISCOVERY_STATE_TYPE,
  REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE
} from '@linearb/linjs-common';
import { ORG_DETECTION_STRATEGY } from './formState.types';

export const INIT_STATE_FROM_DISCOVERY_SETTING =
  'INIT_STATE_FROM_DISCOVERY_SETTING';
export const TOGGLE_IS_ACTIVE = 'TOGGLE_IS_ACTIVE';
export const SET_INCLUSION_REGEX = 'SET_INCLUSION_REGEX';
export const SET_EXCLUISION_REGEX = 'SET_EXCLUISION_REGEX';
export const ON_CHANGE_GITHUB_ORG = 'ON_CHANGE_GITHUB_ORG';
export const ON_CHANGE_VISIBILITY = 'ON_CHANGE_VISIBILITY';
export const FILTER_UN_EXISTED_ORGS = 'FILTER_UN_EXISTED_ORGS';
export const SWITCH_ORG_DETECTION_STRATEGY = 'SWITCH_ORG_DETECTION_STRATEGY';
export const SET_ORG_DETECTION_STRATEGY_REGEX =
  'SET_ORG_DETECTION_STRATEGY_REGEX';

const getSettingOrgDetectionStrategy = setting => {
  if (setting?.extra?.github_orgs_discovery_regex)
    return ORG_DETECTION_STRATEGY.REGEX;

  return ORG_DETECTION_STRATEGY.ORG_SELECTION;
};

export const initFormStateFromDiscoverySetting =
  integrationDiscoverySetting => {
    const setting = integrationDiscoverySetting?.value;
    const defaultVisibility =
      setting?.extra?.visibility?.length > 0
        ? setting.extra.visibility
        : [REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE.PRIVATE];

    const defaultOrgDetectionStrategy = getSettingOrgDetectionStrategy(setting);

    return {
      type: INIT_STATE_FROM_DISCOVERY_SETTING,
      payload: {
        filter: {
          inclusion_regex: setting?.filter?.inclusion_regex || '',
          exclusion_regex: setting?.filter?.exclusion_regex || ''
        },
        extra: {
          ...(setting?.extra || {}),
          github_orgs: setting?.extra?.github_orgs || [],
          github_orgs_discovery_regex:
            setting?.extra?.github_orgs_discovery_regex || '.*',
          visibility: defaultVisibility
        },
        state: setting?.state || REPOS_AUTO_DISCOVERY_STATE_TYPE.ACTIVE,
        orgDetectionStrategy: defaultOrgDetectionStrategy
      }
    };
  };

export const toggleIsActive = () => ({
  type: TOGGLE_IS_ACTIVE
});

export const setInclusionRegex = str => ({
  type: SET_INCLUSION_REGEX,
  payload: str
});

export const setExclusionRegex = str => ({
  type: SET_EXCLUISION_REGEX,
  payload: str
});

export const onChangeGithubOrg = selectedOrgs => ({
  type: ON_CHANGE_GITHUB_ORG,
  payload: selectedOrgs
});

export const onChangeVisibility = selectedValues => ({
  type: ON_CHANGE_VISIBILITY,
  payload: selectedValues
});

export const filterUnExistedOrgs = githubOrgsNames => ({
  type: FILTER_UN_EXISTED_ORGS,
  payload: githubOrgsNames
});

export const switchOrgDetectionStrategy = strategy => ({
  type: SWITCH_ORG_DETECTION_STRATEGY,
  payload: strategy
});

export const setOrgDetectionStrategyRegex = value => ({
  type: SET_ORG_DETECTION_STRATEGY_REGEX,
  payload: value
});
